import { Button, Modal, Stack, ThemeIcon } from "@mantine/core";
import { useLanguageStore } from "../../stores/languageStore";
import { GrLanguage } from "react-icons/gr";
import { supportedLanguages } from "../../config/i18n";
import { useTranslation } from "react-i18next";
import { useDisclosure } from "@mantine/hooks";

interface LanguageSwitcherProps {
  availableLanguages?: string[];
}

function LanguageSwitcher({ availableLanguages }: LanguageSwitcherProps) {
  const [isOpen, handlers] = useDisclosure();
  const { t } = useTranslation("fixed");
  const currentLanguage = useLanguageStore((state) => state.currentLanguage);
  const setLanguage = useLanguageStore((state) => state.setLanguage);

  const languagesToShow = availableLanguages
    ? supportedLanguages.filter((lang) => availableLanguages.includes(lang))
    : supportedLanguages;

  const handleLanguageSelect = (lang: string) => {
    setLanguage(lang);
    handlers.close();
  };

  return (
    <>
      <Button
        onClick={() => handlers.open()}
        variant="subtle"
        leftSection={
          <ThemeIcon size="xs" variant="transparent" c="inherit">
            <GrLanguage style={{ width: "100%", height: "100%" }} />
          </ThemeIcon>
        }
        h="auto"
        mih="unset"
        px="xs"
        py="xxs"
        lh={1}
        fz="md"
        fw={400}
      >
        {currentLanguage.toUpperCase()}
      </Button>

      <Modal opened={isOpen} onClose={handlers.close} title="Select Language" size="sm" centered>
        <Stack gap="md" align="stretch">
          {languagesToShow.map((lang) => (
            <Button
              key={lang}
              onClick={() => handleLanguageSelect(lang)}
              fullWidth
              variant="subtle"
              aria-pressed={currentLanguage === lang}
              fz="md"
            >
              {t(`language.fullName.${lang}`)}
            </Button>
          ))}
        </Stack>
      </Modal>
    </>
  );
}

export default LanguageSwitcher;
